import React from 'react';

import EmptyList from 'components/EmptyList';
import useStoreTranslation from 'hooks/useStoreTranslation';

const BranchCompanyEmptyList = () => {
  const { t } = useStoreTranslation();
  return (
    <EmptyList
      grey
      paddingMessage={54}
      title={t('branchCompany.list.emptyView.title')}
      description={t('branchCompany.list.emptyView.text')}
      image="/corporate/images/group-2.svg"
      backgroundImage="/corporate/images/group-3.svg"
    />
  );
};

export default BranchCompanyEmptyList;
